import { IconArrowDown, IconArrowUp } from "@Theme/common/Icon.styled"

import { IMenu } from "@Interfaces/IMenu"

export const sideBarData: IMenu[] = [
  {
    title: "Inicio",
    path: "/dashboard",
    iconClosed: <IconArrowDown />,
    iconOpened: <IconArrowUp />,
  },
  {
    title: "Pedidos",
    iconClosed: <IconArrowDown />,
    iconOpened: <IconArrowUp />,
    path: "/order",

    subNav: [],
  },
  {
    title: "Reportes",
    path: "/report",
  },
]
